import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import type { TextTitledBodyData } from "@/types/storyboard";
import { resolveProblemSolvingContent } from "@/components/storyboard/text/utils/resolveProblemSolvingContent";

interface Props {
  data: TextTitledBodyData | string;
}

export const TextProblemSolving = ({ data }: Props) => {
  const content = resolveProblemSolvingContent(data);
  const title = "title" in content ? content.title : undefined;

  return (
    <ContentBlock title={title}>
      <div className="prose max-w-full text-primary">
        <CourseMarkdown>{content.body}</CourseMarkdown>
      </div>
    </ContentBlock>
  );
};
